import { toLocaleString } from "@/shared/lib/to-locale-string";
import { FC, useEffect, useState } from "react";

interface PaginationProps {
    page: number
    totalPages: number
    totalCount?: number
    setPage: (arg0: number) => void
}

export const Pagination: FC<PaginationProps> = ({ totalPages, totalCount, page, setPage }) => {
    const [start, setStart] = useState<number>(0)
    const [end, setEnd] = useState<number>(5)

    const handleBack = () => {
        if (start <= 0) {
            return
        }
        setStart(prev => Math.max(0, prev - 1))
        setEnd(prev => Math.min(totalPages, prev - 1))
    }

    const handleNext = () => {
        if (end >= totalPages - 2) {
            return
        }
        setStart(prev => Math.max(0, prev + 1))
        setEnd(prev => Math.min(totalPages, prev + 1))
    }

    useEffect(() => {
        if (page > start && page <= end) return
        if (page < start) {
            if (page - 3 >= 0) {
                setStart(Math.max(0, page - 3))
                setEnd(Math.min(totalPages, page + 2))
            } else {
                setStart(0)
                setEnd(Math.min(totalPages, 5))
            }
        }
        if (page > end) {
            if (page + 2 <= totalPages) {
                setStart(Math.max(0, page - 3))
                setEnd(Math.min(totalPages, page + 2))
            } else {
                setStart(Math.max(0, totalPages - 7))
                setEnd(Math.min(totalPages, totalPages - 2))
            }
        }
    }, [page, totalPages])

    return (
        <div className='flex w-full items-center justify-between mt-1'>
            <nav className="flex items-center gap-2">
                <a onClick={handleBack} className="py-3 px-[14px] hover:cursor-pointer text-[14px] font-semibold text-[#828282]">
                    Назад
                </a>
                {Array.from({ length: totalPages || 1 }, ((_, i) => i + 1)).slice(start, end).map((value, index) =>
                    <button 
                        key={index} 
                        onClick={() => setPage(value)} 
                        className={`hover:cursor-pointer w-8 h-8 font-semibold text-[14px] border-color-dark border rounded-full transition ${page === value ? 'bg-color-dark text-white' : 'bg-white text-color-dark hover:bg-color-dark hover:text-white'}`}
                    >
                        {value}
                    </button>
                )}
                {(end < totalPages - 2) &&
                    <button 
                        className={`hover:cursor-pointer w-8 h-8 font-semibold text-[14px] border-color-dark border rounded-full transition bg-white text-color-dark hover:bg-color-dark hover:text-white`}
                    >
                        ...
                    </button>
                }
                {(end === totalPages - 2) &&
                    <button
                        onClick={() => setPage(totalPages - 1)} 
                        className={`hover:cursor-pointer w-8 h-8 font-semibold text-[14px] border-color-dark border rounded-full transition ${page === totalPages - 1 ? 'bg-color-dark text-white' : 'bg-white text-color-dark hover:bg-color-dark hover:text-white'}`}
                    >
                        {totalPages - 1}
                    </button>
                }
                {(end < totalPages) &&
                    <button 
                        onClick={() => setPage(totalPages)} 
                        className={`hover:cursor-pointer w-8 h-8 font-semibold text-[14px] border-color-dark border rounded-full transition ${page === totalPages ? 'bg-color-dark text-white' : 'bg-white text-color-dark hover:bg-color-dark hover:text-white'}`}
                    >
                        {totalPages}
                    </button>
                }
                <a onClick={handleNext} className="py-3 px-[14px] hover:cursor-pointer text-[14px] font-semibold text-[#828282]">
                    Далее
                </a>
            </nav>
            {Boolean(totalCount) &&
                <div className="text-sm">
                    Всего: <span className="font-bold">{toLocaleString(totalCount)}</span>
                </div>
            }
        </div>
    )
}
